import { get, post, put } from "aws-amplify/api";

import OwnerSearchModal from "containers/owner/OwnerSearchModal";
import AgentSelector from "containers/sale/sections/AgentSelector";
import DuplicateCheckCard from "containers/sale/sections/DuplicateCheckCard";
import RecordHistoryTab from "containers/sale/sections/RecordHistoryTab";
import SaleCoreFields from "containers/sale/sections/SaleCoreFields";
import SaleFlagsPanel from "containers/sale/sections/SaleFlagsPanel";
import SaleRelationsPanel from "containers/sale/sections/SaleRelationsPanel";
import React, { Component } from "react";
import { Alert, Button, Card, Col, Form, Modal, Nav, Row, Tab, Tabs } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { PacmanLoader } from "react-spinners";
import "../common/Detail.css";



export class SaleDetail extends Component {
  constructor(props) {
    super(props);

    this.updateTableState = this.updateTableState.bind(this);
    this.saveRecord = this.saveRecord.bind(this);
    this.refreshDataSet = this.refreshDataSet.bind(this);
    this.validateRelatedRecord = this.validateRelatedRecord.bind(this);
    this.getProperties = this.getProperties.bind(this);
    this.setAppendixNo = this.setAppendixNo.bind(this);
    this.removeHold = this.removeHold.bind(this);

    this.state = {
      isLoading: null,
      isDeleting: null,
      modified: false,
      sale: null,
      showAlert: false,
      errorMessage: "",
      propertyidlist: [],
      textDates: false,
      areaSum: 0,

      saleReviewFilter: {},
      buyerSellerFilter: {},
      propertySaleFilter: {},
      addressFilter: { propertyid: -1 },
      ownerFilter: { propertyid: -1 },

      propertySales: [],
      showPropertySaleDialog: false,
      issueDate: null,
      cityscope: null,
      showOwnerSearchDialog: false,

      buyerSellers: [],

      buyerSellerOptions: [
        { value: false, label: "Buyer" },
        { value: true, label: "Vendor" },
      ],

      selectedSuburb: null,
      suburbOptions: [],

      incomeBasisOptions: [
        { value: "G", label: "Gross" },
        { value: "N", label: "Net" },
      ],
      selectedIncomeBasis: null,

      selectedAppendix: null,
      appendixOptions: [],

      idList: [],
      previousId: null,
      nextId: null,

      property_key: this.props.match.params.propertyid,
      primaryCategory: this.props.location.state ? (this.props.location.state.primaryCategory ? this.props.location.state.primaryCategory : null) : null,
      property_id: null,
      selectedClassification: null,
      classificationOptions: [],
      agentOptions: [],
      coAgentOptions: [],
      agentSearchString: null,
      agentInterstateFlag: false,
      agentMenuIsOpen: false,
      coAgentSearchString: null,
      coAgentInterstateFlag: false,
      coAgentMenuIsOpen: false,
      selectedAgent: null,
      selectedCoAgent: null,
      showAgentDropDown: false,
      showCoAgentDropDown: false,

      sale_id: null,
      sale_date: null,
      contract_date: null,
      transfer_date: null,
      sale_price: null,
      interest_transferred: null,
      city_code: null,
      appendix: null,
      entity_id_agent: null,
      agent: null,
      agent_name: null,
      entity_id_co_agent: null,
      co_agent: null,
      co_agent_name: null,
      tmp_prop: null,
      transfer_number: null,
      sale_notes: null,
      mortgagee_receiver_sale: false,
      off_the_plan: false,
      related_parties: false,
      company_transfer: false,
      includes_car_park: this.props.location.state ? (this.props.location.state.isUnit ? this.props.location.state.isUnit : false) : false,
      extraordinary: false,
      leasehold: false,
      part_interest: false,
      checked_duplicate: false,
      classification_code: null,
      classification: null,
      income: null,
      income_basis: null,
      yieldamt: null,
      income_yield_notes: null,
      is_commercial_office: null,
      is_nla_2000: false,
      strata_office_exception: false,
      date_written_to_monitor: null,
      monitor_cityscope_reference: null,
      created_date: null,
      created_by: "",
      last_edited_date: null,
      last_edited_by: "",
    };
  }

  async apiGet(path, queryStringParameters) {
    const request = get({
      apiName: "colin",
      path,
      options: queryStringParameters ? { queryParams: queryStringParameters } : {},
    });
    const { body } = await request.response;
    return await body.json();
  }

  async apiPost(path, body) {
    const request = post({
      apiName: "colin",
      path,
      options: { body },
    });
    const { body: responseBody } = await request.response;
    return await responseBody.json();
  }

  async apiPut(path, body) {
    const request = put({
      apiName: "colin",
      path,
      options: { body },
    });
    const { body: responseBody } = await request.response;
    return await responseBody.json();
  }

  normalizeCollectionResponse(payload, collectionKeys = []) {
    if (Array.isArray(payload)) {
      return payload;
    }

    if (!payload || typeof payload !== "object") {
      return [];
    }

    const defaultKeys = ["items", "data", "results", "rows", "records"];
    const keysToCheck = [...collectionKeys, ...defaultKeys];

    for (let i = 0; i < keysToCheck.length; i++) {
      const key = keysToCheck[i];
      if (Array.isArray(payload[key])) {
        return payload[key];
      }
    }

    return [];
  }

  getCurrentSaleFilters() {
    const saleId = this.state.sale_id || this.props.match.params.id;

    if (!saleId || String(saleId).indexOf("new") >= 0) {
      return {
        saleId: null,
        saleReviewFilter: this.state.saleReviewFilter,
        buyerSellerFilter: this.state.buyerSellerFilter,
        propertySaleFilter: this.state.propertySaleFilter,
      };
    }

    return {
      saleId,
      saleReviewFilter: { saleid: saleId },
      buyerSellerFilter: { saleid: saleId },
      propertySaleFilter: { saleid: saleId },
    };
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.match.params.id !== prevProps.match.params.id) {
      const sale_id = this.props.match.params.id;
      this.setState(
        {
          isLoading: null,
          isDeleting: null,
          modified: false,
          sale: null,
          showAlert: false,
          errorMessage: "",

          textDates: false,
          areaSum: 0,

          saleReviewFilter: { saleid: sale_id },
          buyerSellerFilter: { saleid: sale_id },
          propertySaleFilter: { saleid: sale_id },
          addressFilter: { propertyid: -1 },
          ownerFilter: { propertyid: -1 },

          propertySales: [],
          showPropertySaleDialog: false,
          issueDate: null,
          cityscope: null,
          showOwnerSearchDialog: false,

          buyerSellers: [],

          buyerSellerOptions: [
            { value: false, label: "Buyer" },
            { value: true, label: "Vendor" },
          ],

          selectedSuburb: null,
          suburbOptions: [],

          incomeBasisOptions: [
            { value: "G", label: "Gross" },
            { value: "N", label: "Net" },
          ],
          selectedIncomeBasis: null,

          selectedAppendix: null,
          appendixOptions: [],

          idList: [],
          previousId: null,
          nextId: null,

          property_key: this.props.match.params.propertyid,
          primaryCategory: this.props.location.state?.primaryCategory || null,
          property_id: null,
          selectedClassification: null,
          classificationOptions: [],
          agentOptions: [],
          coAgentOptions: [],
          agentSearchString: null,
          agentInterstateFlag: false,
          agentMenuIsOpen: false,
          coAgentSearchString: null,
          coAgentInterstateFlag: false,
          coAgentMenuIsOpen: false,
          selectedAgent: null,
          selectedCoAgent: null,
          showAgentDropDown: false,
          showCoAgentDropDown: false,

          sale_id: sale_id,
          sale_date: null,
          contract_date: null,
          transfer_date: null,
          sale_price: null,
          interest_transferred: null,
          city_code: null,
          appendix: null,
          entity_id_agent: null,
          agent: null,
          agent_name: null,
          entity_id_co_agent: null,
          co_agent: null,
          co_agent_name: null,
          tmp_prop: null,
          transfer_number: null,
          sale_notes: null,
          mortgagee_receiver_sale: false,
          off_the_plan: false,
          related_parties: false,
          company_transfer: false,
          includes_car_park: false,
          extraordinary: false,
          leasehold: false,
          part_interest: false,
          checked_duplicate: false,
          classification_code: null,
          classification: null,
          income: null,
          income_basis: null,
          yieldamt: null,
          income_yield_notes: null,
          is_commercial_office: null,
          is_nla_2000: false,
          strata_office_exception: false,
          date_written_to_monitor: null,
          monitor_cityscope_reference: null,
          created_date: null,
          created_by: "",
          last_edited_date: null,
          last_edited_by: "",
        },
        this.loadNewSale
      );
    }
  }

  async componentDidMount() {
    const isNewPropertySale = this.props.match.params.id.indexOf("new") >= 0
      && Boolean(this.props.match.params.propertyid);

    //If not a new sale, get the saleid
    if (this.props.match.params.id.indexOf("new") < 0) {
      this.setState({
        saleReviewFilter: { saleid: this.props.match.params.id },
        buyerSellerFilter: { saleid: this.props.match.params.id },
        propertySaleFilter: { saleid: this.props.match.params.id },
        property_key: this.props.match.params.propertyid,
        primaryCategory: this.props.location.state ? (this.props.location.state.primaryCategory ? this.props.location.state.primaryCategory : null) : null,
        sale_id: this.props.match.params.id,
      });
    }

    if (this.props.location.state) {
      if (this.props.location.state.propertyidlist) {
        this.setState({ propertyidlist: this.props.location.state.propertyidlist });
      }
    }

    try {
      this.setState({ isLoading: true });
      if (this.props.match.params.id.indexOf("new") >= 0) {
        const propertyId = this.props.location.search.replace("?propertyid=", "");
        let primaryCategory = this.state.primaryCategory;

        if (isNewPropertySale && !primaryCategory && propertyId) {
          const response = await this.apiGet(`/properties/${propertyId}/propertyclassifications`, { propertyid: propertyId });
          const propertyClassifications = this.normalizeCollectionResponse(response);
          primaryCategory = propertyClassifications.find((classification) => Number(classification.sort_order) === 1)
            || propertyClassifications[0]
            || null;
          await new Promise((resolve) => this.setState({ primaryCategory }, resolve));
        }

        this.setState({ property_id: propertyId, mortgagee_receiver_sale: false, off_the_plan: false, related_parties: false, company_transfer: false, includes_car_park: this.props.location.state ? (this.props.location.state.isUnit ? this.props.location.state.isUnit : false) : false, classification_code: isNewPropertySale ? primaryCategory?.classification_code : null, classification: isNewPropertySale ? primaryCategory?.classification : null, extraordinary: false, leasehold: false, part_interest: false, checked_duplicate: false, is_nla_2000: false, strata_office_exception: false, is_commercial_office: false, created_by: this.props.user, interest_transferred: 100, cityscope: this.props.match.params.propertyid ? this.props.match.params.propertyid.substring(0, 2) : null });
        await this.syncroniseState();
        const newSaleAppendixOptions = await this.loadLookupData(this.props.match.params.propertyid.substring(0, 2), primaryCategory);
        this.setAppendix(newSaleAppendixOptions);
        document.title = "New sale for " + this.state.property_key;
      } else {
        await this.loadNewSale();
      }

      this.setState({ isLoading: false });
    } catch (e) {
      alert(e);
    }
  }

  async loadLookupData(cityscope, primaryCategoryOverride = null) {
    const classificationOptions = await this.getClassifications();
    if (classificationOptions) {
      this.setState((state) => {
        const primaryCategory = primaryCategoryOverride || state.primaryCategory;
        const selectedClassification = this.props.match.params.id.indexOf("new") >= 0
          && Boolean(this.props.match.params.propertyid)
          && primaryCategory
          ? classificationOptions.find((option) =>
              String(option?.value ?? "") === String(primaryCategory.classification_code ?? "")
              || String(option?.label ?? "") === String(primaryCategory.classification ?? "")
            )
          : null;

        if (!selectedClassification) {
          return { classificationOptions };
        }

        return {
          classificationOptions,
          classification_code: selectedClassification.value,
          classification: selectedClassification.label,
          selectedClassification,
        };
      });
    }

    const appendixOptions = await this.getAppendix({ cityscope: cityscope });
    if (appendixOptions) {
      this.setState((state) => ({ appendixOptions }));
    }

    return appendixOptions || [];
  }

  // Takes options directly because setState from loadLookupData has not flushed yet.
  setAppendix(loadedAppendixOptions) {
    const appendixOptions = loadedAppendixOptions || this.state.appendixOptions;
    //If we have loaded the appendix options
    if (appendixOptions) {
      //If the sale already has an appendix, then get the issue_date
      if (this.state.appendix) {
        for (let i = 0; i < appendixOptions.length; i++) {
          if (appendixOptions[i].value === this.state.appendix) {
            this.setState({ issue_date: appendixOptions[i].issue_date });
            break;
          }
        }
      }
      //else pick the next appendix date for the scope
      else {
        for (let i = 0; i < appendixOptions.length; i++) {
          // UAT compared loosely here; current_appendix and value can differ in type.
          if (appendixOptions[i].current_appendix != null && String(appendixOptions[i].current_appendix) === String(appendixOptions[i].value)) {
            this.setState({ appendix: appendixOptions[i].value, selectedAppendix: { value: appendixOptions[i].value, label: appendixOptions[i].label }, issue_date: appendixOptions[i].issue_date });
            break;
          }
        }
      }
    }
  }

  async loadNewSale() {
    const { saleId, saleReviewFilter, buyerSellerFilter, propertySaleFilter } = this.getCurrentSaleFilters();

    if (saleId && this.state.sale_id !== saleId) {
      this.setState({
        sale_id: saleId,
        saleReviewFilter,
        buyerSellerFilter,
        propertySaleFilter,
      });
    }

    const saleLoaded = await this.retrieveSale();
    if (!saleLoaded) {
      return;
    }

    //Set drop down values
    this.setState({ selectedAppendix: { value: this.state.appendix, label: this.state.appendix } });
    this.setState({ selectedClassification: { value: this.state.classification_code, label: this.state.classification } });

    if (this.state.income_basis) {
      let label = "";
      try {
        label = this.state.incomeBasisOptions.find((o) => o.value === this.state.income_basis).label;
      } catch {
        label = this.state.income_basis;
      }
      this.setState({ selectedIncomeBasis: { value: this.state.income_basis, label: label } });
    }

    //Handle prev next buttons
    if (this.props.location.state) {
      if (this.props.location.state.hasOwnProperty("data")) {
        const idList = this.props.location.state.data;
        var currentIdIndex = idList.findIndex((id) => String(id) === String(this.props.match.params.id));

        let nextId = null;
        let previousId = null;

        if (currentIdIndex + 1 < idList.length) {
          nextId = idList[currentIdIndex + 1];
        }
        if (currentIdIndex > 0) {
          previousId = idList[currentIdIndex - 1];
        }
        this.setState({ idList: idList, nextId: nextId, previousId: previousId, currentIdIndex: currentIdIndex });
      }
    }

    //get properties

    await this.getProperties(propertySaleFilter);

    //Sum property areas
    if (this.state.propertySales.length > 0) {
      let areaSum = 0;
      for (let i = 0; i < this.state.propertySales.length; i++) {
        if (this.state.propertySales[i].hasOwnProperty("site_area")) {
          if (this.state.propertySales[i].site_area !== null) {
            areaSum += this.state.propertySales[i].site_area;
          }
        }
      }
      this.setState({ areaSum });
    }

    //Get buyers / sellers
    try {
      await this.getBuyerSellers(buyerSellerFilter);
    } catch {
      alert("Error loading property sales");
    }

    //Get lookup data
    if (this.state.propertySales.length > 0) {
      const existingSaleAppendixOptions = await this.loadLookupData(this.state.propertySales[0].property_key.substring(0, 2));
      this.setAppendix(existingSaleAppendixOptions);
    }

    if (this.state.entity_id_agent) {
      this.setState((state) => ({ selectedAgent: { value: this.state.entity_id_agent, label: this.state.agent } }));
    }
    if (this.state.entity_id_co_agent) {
      this.setState((state) => ({ selectedCoAgent: { value: this.state.entity_id_co_agent, label: this.state.co_agent } }));
    }

    if (this.state.entity_id_agent) {
      const agentOptions = await this.getAgents({ entityid: this.state.entity_id_agent });
      this.setState((state) => ({ agentOptions }));
      this.setState((state) => ({ showAgentDropDown: true }));
    }

    if (this.state.entity_id_co_agent) {
      const coAgentOptions = await this.getCoAgents({ entityid: this.state.entity_id_co_agent });
      this.setState((state) => ({ coAgentOptions }));
      this.setState((state) => ({ showCoAgentDropDown: true }));
    }

    document.title = "sale " + this.state.sale_id;
  }

  async syncroniseState() {
    const sale = {
      sale_id: this.state.sale_id,
      sale_date: this.state.sale_date,
      contract_date: this.state.contract_date,
      transfer_date: this.state.transfer_date,
      sale_price: this.state.sale_price,
      interest_transferred: this.state.interest_transferred,
      city_code: this.state.city_code,
      appendix: this.state.appendix,
      issue_date: this.state.issue_date,
      entity_id_agent: this.state.entity_id_agent,
      agent: this.state.agent,
      agent_name: this.state.agent_name,
      entity_id_co_agent: this.state.entity_id_co_agent,
      co_agent: this.state.co_agent,
      co_agent_name: this.state.co_agent_name,
      tmp_prop: this.state.tmp_prop,
      transfer_number: this.state.transfer_number,
      sale_notes: this.state.sale_notes,
      mortgagee_receiver_sale: this.state.mortgagee_receiver_sale,
      off_the_plan: this.state.off_the_plan,
      related_parties: this.state.related_parties,
      company_transfer: this.state.company_transfer,
      includes_car_park: this.state.includes_car_park,
      extraordinary: this.state.extraordinary,
      leasehold: this.state.leasehold,
      part_interest: this.state.part_interest,
      checked_duplicate: this.state.checked_duplicate,
      classification_code: this.state.classification_code,
      classification: this.state.classification,
      income: this.state.income,
      income_basis: this.state.income_basis,
      yieldamt: this.state.yieldamt,
      income_yield_notes: this.state.income_yield_notes,
      is_commercial_office: this.state.is_commercial_office,
      is_nla_2000: this.state.is_nla_2000,
      strata_office_exception: this.state.strata_office_exception,
      date_written_to_monitor: this.state.date_written_to_monitor,
      monitor_cityscope_reference: this.state.monitor_cityscope_reference,
      created_date: this.state.created_date,
      created_by: this.state.created_by,
      last_edited_date: this.state.last_edited_date,
      last_edited_by: this.state.last_edited_by,
    };

    this.setState({ sale });
  }

  async retrieveSale() {
    const sale = await this.getSale();

    // getSale swallows request failures and returns null.
    if (!sale) {
      this.setState({
        errorMessage: "Unable to load this sale record. Please refresh the page (F5) to try again.",
        showAlert: true,
      });
      return false;
    }

    const { sale_id, sale_date, contract_date, transfer_date, sale_price, interest_transferred, city_code, appendix, issue_date, entity_id_agent, agent, agent_name, entity_id_co_agent, co_agent, co_agent_name, tmp_prop, transfer_number, sale_notes, mortgagee_receiver_sale, off_the_plan, related_parties, company_transfer, includes_car_park, extraordinary, leasehold, part_interest, checked_duplicate, classification_code, classification, income, income_basis, yieldamt, income_yield_notes, is_commercial_office, is_nla_2000, strata_office_exception, date_written_to_monitor, monitor_cityscope_reference, created_date, created_by, last_edited_date, last_edited_by } = sale;

    this.setState({
      sale,
      sale_id,
      sale_date,
      contract_date,
      transfer_date,
      sale_price,
      interest_transferred,
      city_code,
      appendix,
      issue_date,
      entity_id_agent,
      agent,
      agent_name,
      entity_id_co_agent,
      co_agent,
      co_agent_name,
      tmp_prop,
      transfer_number,
      sale_notes,
      mortgagee_receiver_sale,
      off_the_plan,
      related_parties,
      company_transfer,
      includes_car_park,
      extraordinary,
      leasehold,
      part_interest,
      checked_duplicate,
      classification_code,
      classification,
      income,
      income_basis,
      yieldamt,
      income_yield_notes,
      is_commercial_office,
      is_nla_2000,
      strata_office_exception,
      date_written_to_monitor,
      monitor_cityscope_reference,
      created_date,
      created_by,
      last_edited_date,
      last_edited_by,
    });

    return true;
  }

  //Call API
  async getSale() {
    try {
      return await this.apiGet(`/sales/${this.props.match.params.id}`);
    } catch (error) {
      console.warn("Unable to load sale", error);
      return null;
    }
  }

  async saveSale(sale) {
    this.setState({ last_edited_by: this.props.user });
    if (this.state.sale_id === null) {
      this.setState({ created_by: this.props.user });
      const response = await this.apiPost(`/sales/new`, sale);
      try {
        return await response;
      } catch (error) {
        alert(error + ". Please refresh the page (F5) to try again.");
      }
    }
    const response = await this.apiPut(`/sales/${this.state.sale_id}`, sale);
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  async removeHold() {
    const confirm2 = window.confirm("Please confirm you have proofed this sale and would like to update the HOLD status of the Properties linked to this Sale?");
    if (confirm2) {
      try {
        const sale = { last_edited_by: this.props.user, released_by: this.props.user };
        const response = await this.apiPut(`/sales/${this.state.sale_id}/withholdings/all`, sale);

        let propertySales = [...this.state.propertySales];
        var i = 0;
        for (i = 0; i < propertySales.length; i++) {
          propertySales[i].withhold_flag = false;
        }
        this.setState({ propertySales });

        return response;
      } catch (error) {
        alert(error + ". Please refresh the page (F5) to try again.");
      }
    }
  }
  async savePropertySaleText(sale) {
    sale.last_edited_by = this.props.user;
    return this.apiPut(`/properties/${sale.property_id}/appendsaleshistory`, sale);
  }

  async getAgents(filter) {
    try {
      const agentOptions = await this.apiGet(`/entities/dropdown`, filter);
      if (agentOptions) {
        this.setState((state) => ({ agentOptions }));
      }
      return agentOptions;
    } catch (error) {
      console.warn("Error getting agents", error);
      return [];
    }
  }

  async getCoAgents(filter) {
    try {
      const coAgentOptions = await this.apiGet(`/entities/dropdown`, filter);
      if (coAgentOptions) {
        this.setState((state) => ({ coAgentOptions }));
      }
      return coAgentOptions;
    } catch (error) {
      console.warn("Error getting agents", error);
      return [];
    }
  }

  async getSuburbs() {
    return await this.apiGet(`/suburbs`);
  }

  async getClassifications() {
    return await this.apiGet(`/classifications`);
  }

  async getProperties(filter) {
    try {
      const response = await this.apiGet("/propertysales", filter);
      const propertySales = this.normalizeCollectionResponse(response, ["propertySales"]);
      if (propertySales) {
        if (propertySales.length > 0 && propertySales[0].hasOwnProperty("property_key")) {
          propertySales.sort(function (a, b) {
            if (a.property_key === b.property_key) {
              return 0;
            }
            if (a.property_key < b.property_key) {
              return -1;
            } else {
              return 1;
            }
          });
        }
        this.setState((state) => ({ propertySales }));
      }
    } catch (error) {
      console.warn("Unable to load properties", error);
    }
  }

  async getBuyerSellers(filter) {
    try {
      const saleId = (filter && filter.saleid) || this.state.sale_id || this.props.match.params.id;
      const requestFilter = saleId ? { ...(filter || {}), saleid: saleId } : (filter || {});
      const response = await this.apiGet("/sales/buyersellers", requestFilter);
      const buyerSellers = this.normalizeCollectionResponse(response, ["buyerSellers"]);
      if (buyerSellers) {
        this.setState((state) => ({ buyerSellers }));
      }
      return buyerSellers;
    } catch (error) {
      console.warn("Error getting buyer sellers", error);
      return [];
    }
  }

  async getAppendix(filter) {
    try {
      return await this.apiGet("/appendix", filter);
    } catch (error) {
      console.warn("Error getting appendix", error);
      return [];
    }
  }

  handleEnterCurrentIdIndex = (event) => {
    if (event.keyCode === 13 || event.keyCode === 9) {
      this.handleGoToRecord();
    }
  };

  handleGoToRecord = (event) => {
    if (this.state.currentIdIndex >= 0 && this.state.currentIdIndex < this.state.idList.length) {
      this.props.history.push(`/sales/${this.state.idList[this.state.currentIdIndex]}`, { data: this.state.idList, propertyidlist: this.state.propertyidlist });
    } else {
      alert("Page no not in range.");
    }
  };

  handleCurrentIdIndexChange = (event) => {
    const val = event.target.value.replace(/[^0-9.]/g, "");
    this.setState({ [event.target.id]: val - 1 });
  };

  handleSuburbChange = (selectedSuburb) => {
    this.setState({ selectedSuburb, suburb: selectedSuburb, modified: true }, this.handleBlur);
  };

  handleIncomeBasisChange = (selectedIncomeBasis) => {
    if (selectedIncomeBasis) {
      this.setState({ selectedIncomeBasis, income_basis: selectedIncomeBasis.value, modified: true }, this.handleBlur);
    } else {
      this.setState({ selectedIncomeBasis: { value: null, label: null }, income_basis: null, modified: true }, this.handleBlur);
    }
  };

  handleClassificationChange = (selectedClassification) => {
    this.setState({ selectedClassification });
    if (selectedClassification) {
      this.setState({ classification_code: selectedClassification.value, modified: true }, this.handleBlur);
    } else {
      this.setState({ classification_code: null, modified: true }, this.handleBlur);
    }
  };

  handleAppendixChange = (selectedAppendix) => {
    this.setState({ selectedAppendix });
    if (selectedAppendix) {
      this.setState({ appendix: selectedAppendix.value, issue_date: selectedAppendix.issue_date, modified: true }, this.handleBlur);
    } else {
      this.setState({ appendix: null, issue_date: null, modified: true }, this.handleBlur);
    }
  };

  handleAgentSearch = async () => {
    try {
      let state = null;
      if (!this.state.agentInterstateFlag) {
        if (this.state.propertySales.length > 0) {
          state = this.state.propertySales[0].state;
        }
      }

      await this.getAgents({ name: this.state.agentSearchString, state: state });
      this.setState({ agentMenuIsOpen: true });
    } catch {
      alert("Error loading agents");
    }
  };

  handleCoAgentSearch = async () => {
    try {
      let state = null;
      if (!this.state.coAgentInterstateFlag) {
        if (this.state.propertySales.length > 0) {
          state = this.state.propertySales[0].state;
        }
      }
      await this.getCoAgents({ name: this.state.coAgentSearchString, state: state });
      this.setState({ coAgentMenuIsOpen: true });
    } catch {
      alert("Error loading agents");
    }
  };

  handleEnterOnAgentSearch = (e) => {
    if (e.keyCode === 13) {
      this.handleAgentSearch();
    }
  };

  handleEnterOnCoAgentSearch = (e) => {
    if (e.keyCode === 13) {
      this.handleCoAgentSearch();
    }
  };

  handleChange = (event) => {
    this.setState({
      [event.target.id]: event.target.value,
    });
    this.setState({ modified: true });
  };

  handlePercentChange = (event) => {
    let val = event.target.value.replace(/[^0-9.]/g, "").replace(/(?<=[.][0-9]{2})[0-9]*/g, "");
    if (val > 100) {
      val = 100;
    }
    let partInterest = this.state.part_interest;

    if (event.target.id === "interest_transferred") {
      if (val !== 100) {
        partInterest = true;
      } else {
        partInterest = false;
      }
    }

    this.setState({ [event.target.id]: val, modified: true, part_interest: partInterest });
  };

  handleNumberChange = (event) => {
    let val = event.target.value.replace(/[^0-9.]/g, "");
    this.setState({
      [event.target.id]: val,
    });
    this.setState({ modified: true });
  };

  handleMoneyChange = (event) => {
    if (event.target.value !== "") {
      let val = event.target.value;
      this.setState({ [event.target.id]: val, modified: true });
    } else {
      this.setState({ [event.target.id]: null, modified: true });
    }
  };

  formatMoney = (value) => {
    return new Intl.NumberFormat("en-AU", {
      style: "currency",
      currency: "AUD",
      minimumFractionDigits: 2,
      currencyDisplay: "symbol",
    }).format(value);
  };

  handleDateChange(date, name) {
    var options = { year: "numeric", month: "long", day: "numeric" };
    var dt = new Date(date);

    if (date) {
      this.setState(
        {
          [name]: dt.toLocaleDateString("en-AU", options),
          modified: true,
        },
        this.setSaleDate
      );
    } else {
      this.setState({
        [name]: null,
        modified: true,
      });
    }
  }

  handleCheckBoxChange = (event) => {
    let name = event.target.name;
    this.setState(
      {
        [name]: event.target.checked,
        modified: true,
      },
      this.handleBlur
    );
  };

  handleAgentChange = async (selectedAgent) => {
    this.setState({ selectedAgent });
    if (selectedAgent) {
      this.setState({ entity_id_agent: selectedAgent.value, agent: selectedAgent.label, agent_name: selectedAgent.name, modified: true }, this.handleBlur);
    } else {
      this.setState({ entity_id_agent: null, agent: null, agent_name: null, modified: true }, this.handleBlur);
    }
    this.setState({ agentMenuIsOpen: false });
  };

  handleCoAgentChange = async (selectedCoAgent) => {
    this.setState({ selectedCoAgent });
    if (selectedCoAgent) {
      this.setState({ entity_id_co_agent: selectedCoAgent.value, co_agent: selectedCoAgent.label, co_agent_name: selectedCoAgent.name, modified: true }, this.handleBlur);
    } else {
      this.setState({ entity_id_co_agent: null, co_agent: null, co_agent_name: null, modified: true }, this.handleBlur);
    }
    this.setState({ coAgentMenuIsOpen: false });
  };

  validateRelatedRecord(record, set) {
    //property
    if (set === "sale") {
      //Sale Date
      if (!this.state.sale_date) {
        return [false, "You must enter a sale date."];
      }

      if (this.state.yieldamt) {
        if (this.state.yieldamt < 0 || this.state.yieldamt > 100) {
          return [false, "Yield must be a number between 0 and 100."];
        }
      }

      if (this.state.interest_transferred !== null && this.state.interest_transferred !== "") {
        if (this.state.interest_transferred < 0 || this.state.interest_transferred > 100) {
          return [false, "Interest Transferred must be a number between 0 and 100."];
        }
      }
    }

    if (set === "propertySales") {
      // secondly check that UnitSort has been specified if required

      if (!record.property_key) {
        return [false, "Enter a Cityscope reference."];
      }
    }

    if (set === "buyerSellers") {
      // secondly check that UnitSort has been specified if required

      // if (!record.share) {
      //     return [false, "Enter buyer share."];
      // }

      if (record.share !== null && record.share !== "") {
        if (record.share > 100 || record.share < 0) {
          return [false, "Enter buyer share between 0 and 100%"];
        }
      }
    }

    return [true];
  }

  setAppendixNo() {
    let dt = new Date(this.state.sale_date);
    dt = dt.setDate(dt.getDate() + 30);
    if (dt < new Date(Date.parse("1999-01-01"))) {
      this.setState({ issue_date: null, selectedAppendix: null, appendix: null, modified: true }, this.handleBlur);
    } else {
      var appendixOptions = [...this.state.appendixOptions].sort(function (a, b) {
        if (a.issue_date < b.issue_date) {
          return -1;
        } else if (a.issue_date > b.issue_date) {
          return 1;
        } else return 0;
      });
      for (var i = 0; i < appendixOptions.length; i++) {
        //the appendix list should already be sorted by date in ascending order
        if (new Date(appendixOptions[i].issue_date) > dt) {
          this.setState({ issue_date: appendixOptions[i].issue_date, selectedAppendix: { value: appendixOptions[i].value, label: appendixOptions[i].label }, appendix: appendixOptions[i].value || "", modified: true }, this.handleBlur);
          return;
        }
      }
    }
  }

  async setSaleDate() {
    let sale_date = this.state.sale_date;

    if (this.state.contract_date != null) {
      sale_date = this.state.contract_date;
    } else if (this.state.transfer_date != null) {
      sale_date = this.state.transfer_date;
    } else {
      sale_date = this.state.sale_date;
    }

    this.setState({ sale_date });
  }

  async calculateYield() {
    const formatter = new Intl.NumberFormat("en-AU", {
      style: "percent",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    if (this.state.sale_price) {
      if (this.state.income) {
        //does yield already have a value?
        if (this.state.yieldamt) {
          const confirm = window.confirm("Is it OK to overwrite the current value of Yield with the new value " + formatter.format(this.state.income.replace(/[^0-9.]/g, "") / this.state.sale_price.replace(/[^0-9.]/g, "")) + "?");
          if (!confirm) {
            return;
          }
        }
        this.setState({ yieldamt: ((this.state.income.replace(/[^0-9.]/g, "") / this.state.sale_price.replace(/[^0-9.]/g, "")) * 100).toFixed(2) });
      } else {
        if (this.state.yieldamt) {
          const confirm2 = window.confirm("Yield cannot be calculated from the current values of Sale Price and Income. Should the current value of Yield " + formatter.format(this.state.yieldamt) + " be cleared?");
          if (confirm2) {
            this.setState({ yieldamt: null });
            return;
          }
        }
      }
    } else {
      this.setState({ yieldamt: null });
      return;
    }
  }

  async calculateIncome() {
    const formatter = new Intl.NumberFormat("en-AU", {
      style: "currency",
      currency: "AUD",
      minimumFractionDigits: 0,
      currencyDisplay: "symbol",
    });

    if (this.state.sale_price) {
      if (this.state.yieldamt) {
        //does income already have a value?
        if (this.state.income) {
          const confirm = window.confirm("Is it OK to overwrite the current value of Income with the new value " + formatter.format((this.state.yieldamt / 100) * this.state.sale_price.replace(/[^0-9.]/g, "")) + "?");
          if (!confirm) {
            return;
          }
        }
        this.setState({ income: formatter.format((this.state.yieldamt / 100) * this.state.sale_price.replace(/[^0-9.]/g, "")) });
      } else {
        const confirm2 = window.confirm("Income cannot be calculated from the current values of Sale Price and Yield. Should the current value of Income " + formatter.format(this.state.income) + " be cleared?");
        if (!confirm2) {
          this.setState({ income: null });
        }
      }
    } else {
      this.setState({ income: null });
      return;
    }
  }

  handleBlur = async (event) => {
    if (event) {
      event.persist();

      if (event.target) {
        const formatMoney = (value) => this.formatMoney(parseFloat(value.replace(/[^0-9.]/g, "")).toFixed(2));

        if (event.target.id === "income" && this.state.modified) {
          await this.setState({ income: formatMoney(this.state.income) });
          await this.calculateYield();
        }

        if (event.target.id === "yieldamt" && this.state.modified) {
          await this.calculateIncome();
        }
      }
    }
    if (this.state.modified === true) {
      this.setState({ showAlert: false, last_edited_by: this.props.user });
      await this.syncroniseState();

      const validation = this.validateRelatedRecord(this.state.sale, "sale");
      if (validation[0] === true) {
        this.setState((state) => ({ modified: false })); //
        if (this.state.entity_id_agent !== null) {
          if (this.state.agent.indexOf("INACTIVE") > 0) {
            this.setState({ errorMessage: "You have selected an inactive  agent, please consider if this is correct. The record will still be saved." });
            this.setState({ showAlert: true });
          }
          if (this.state.propertySales.length > 0 && this.state.propertySales[0].state) {
            if (this.state.agent.toUpperCase().indexOf(this.state.propertySales[0].state.toUpperCase()) === -1) {
              this.setState({ errorMessage: "You have selected an agent in another state, please consider if this is correct. The record will still be saved." });
              this.setState({ showAlert: true });
            }
          }
        }
        if (this.state.entity_id_co_agent !== null) {
          if (this.state.co_agent.indexOf("INACTIVE") > 0) {
            this.setState({ errorMessage: "You have selected an inactive co agent, please consider if this is correct. The record will still be saved." });
            this.setState({ showAlert: true });
          }
          if (this.state.propertySales.length > 0 && this.state.propertySales[0].state) {
            if (this.state.co_agent.toUpperCase().indexOf(this.state.propertySales[0].state.toUpperCase()) === -1) {
              this.setState({ errorMessage: "You have selected a co agent in another state, please consider if this is correct. The record will still be saved." });
              this.setState({ showAlert: true });
            }
          }
        }

        try {
          if (this.props.match.params.id.indexOf("new") >= 0) {
            this.setState({ isLoading: true });
          }
          const result = await this.saveSale(this.state.sale);
          this.setState({ isLoading: false });
          if (result.result === false) {
            alert(result.error_message);
          } else {
            if (this.props.match.params.id.indexOf("new") >= 0) {
              const newSaleId = result.id;
              this.setState((state) => ({ sale_id: newSaleId }));
              //Create relation to property
              await this.addPropertyRelation(newSaleId);

              this.props.history.push("/sales/" + newSaleId);
              //Refresh properties and the actual sales so we can return info from the db
              //  await this.getProperties({ saleid: result.id });
              //   await this.retrieveSale();
              if (!this.state.appendix && this.state.propertySales.length > 0) {
                this.setState({ appendix: this.state.propertySales[0].current_appendix, selectedAppendix: { value: this.state.propertySales[0].current_appendix, label: this.state.propertySales[0].current_appendix } });
              }
            }
          }
        } catch (e) {
          alert(e);
        }
      } else {
        this.setState({ errorMessage: validation[1] });
        this.setState({ showAlert: true });
      }
    }
  };

  async refreshDataSet(dataset) {
    //Get nabers records
    if (dataset === "buyerSellers") {
      const { buyerSellerFilter } = this.getCurrentSaleFilters();
      try {
        await this.getBuyerSellers(buyerSellerFilter);
      } catch {
        alert("Error loading property sales");
      }
    }
  }

  updateTableState(data, set) {
    this.setState({
      [set]: data,
    });
  }

  async saveRecord(record, endpoint, id) {
    record.last_edited_by = this.props.user;
    //If the record is a new record perform a post
    if (record.hasOwnProperty("new_record")) {
      if (record.new_record === true) {
        record.last_edited_by = this.props.user;
        if (endpoint !== "propertySales") {
          return await this.apiPost(`/sales/${this.state.sale_id}/${endpoint.toLowerCase()}/new`, record);
        } else {
          return await this.apiPost(`/${endpoint.toLowerCase()}/new`, record);
        }
      }
    }
    //If not a new record and updating an existing, perform a put
    if (endpoint !== "propertySales") {
      return this.apiPut(`/sales/${this.state.sale_id}/${endpoint.toLowerCase()}/${record[id]}`, record);
    } else {
      return this.apiPut(`/${endpoint.toLowerCase()}/${record[id]}`, record);
    }
  }

  deleteRecord = async () => {
    alert("Delete is temporarily disabled while Sale Detail sections are being migrated.");
  };

  async addPropertyRelation(saleId) {
    let data = [...this.state.propertySales];

    //Update the following with the minimum details to create a record (all not nulls populated)
    //Requires updating per dataset
    let last_sale = Math.ceil(Math.abs(new Date(this.state.sale_date).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24)) < 365 ? true : false;
    if (data.length === 0) {
      last_sale = true;
    }

    data.push({
      property_id: this.state.property_id,
      property_key: this.state.property_key,
      sale_id: saleId,
      created_by: this.props.user,
      last_edited_by: this.props.user,
      last_sale: last_sale,
      new_record: true,
    });

    this.updateTableState(data, "propertySales");

    const result = await this.saveRecord(data[0], "propertySales", "property_sale_id");
    if (result.result) {
      data[0].property_sale_id = result.id;
      data[0].new_record = false;
      this.updateTableState(data, "propertySales");
    } else {
      this.setState({ errorMessage: result.error_message });
      this.setState({ showAlert: true });
    }

    return;
  }

  //This should be pushed back to the DB. We did it here originally because the user may not apply the change once generated, but the function to
  // create the text could still sit in the db
  handleBuildSalesText = async (event) => {
    let strText = "";

    try {
      const response = await this.apiGet(`/sales/${this.props.match.params.id}/salestext`, { dates_as_text: this.state.textDates });
      strText = response[0].sales_text_not_suppressed;
    } catch (e) {
      console.error("Unable to build sales text:", e);
      alert("Unable to build sales text.");
      return;
    }

    const pasteToProperties = window.confirm(strText + "\n\nDo you want to paste this text at the end of the Sales History paragraphs for each of the properties involved in the sale?");

    if (pasteToProperties) {
      for (var i = 0; i < this.state.propertySales.length; i++) {
        await this.savePropertySaleText({ property_id: this.state.propertySales[i].property_id, sales_text: strText });
      }
      alert("The text has been successfully appended to the end of the Sale History paragraph. THE ENTRY STILL NEEDS TO BE PROOFED AND EDITED.");
    } else {
      alert("No text was pasted.");
    }
  };

  handleDelete = async (event) => {
    event.preventDefault();
    if (event.detail !== 0) {
      if (!this.state.registered) {
        if (this.state.propertySales.length === 0) {
          if (this.state.buyerSellers.length === 0) {
            const confirmed = window.confirm("Are you sure you want to delete this sale?");

            if (!confirmed) {
              return;
            } else {
              this.setState({ archived_date: new Date() }, () =>
                this.syncroniseState().then(async () => {
                  const result = await this.saveSale(this.state.sale);
                  if (result.result === false) {
                    alert(result.error_message);
                  } else {
                    this.props.history.push("/properties");
                  }
                })
              );
            }
          } else {
            window.alert("Sale cannot be deleted as it is linked to buyers/sellers");
          }
        } else {
          window.alert("Sale cannot be deleted as it is linked to properties");
        }
      } else {
        window.alert("Record cannot be deleted");
      }
    }
  };

  toggleOwnerSearchDialog = async () => {
    this.setState({
      showOwnerSearchDialog: !this.state.showOwnerSearchDialog,
    });
  };

  togglePropertySaleModal = () => {
    this.setState({
      showPropertySaleDialog: !this.state.showPropertySaleDialog,
    });
  };

  removeVendorAsOwner = async () => {
    const confirmed = window.confirm("Remove the vendors of this sale from all Properties linked to this sale?");

    if (confirmed) {
      //back end handles the blank body and grabs all owners against a sale id
      await this.apiPut(`/propertyowners/frombuyervendor`, { created_by: this.props.user, last_edited_by: this.props.user, saleid: this.state.sale_id });
    }
  };
  addOwnerAsBuyerSeller = async () => {
    const confirmed = window.confirm("Add the current Property Owners to this Sale as Buyers/Vendors?");

    if (confirmed) {
      //back end handles the blank body and grabs all owners against a sale id
      await this.apiPost(`/sales/${this.state.sale_id}/buyersellers/fromproperty`, { created_by: this.props.user, last_edited_by: this.props.user, buyer_vendor: true });

      await this.apiPost(`/sales/${this.state.sale_id}/buyersellers/fromproperty`, { created_by: this.props.user, last_edited_by: this.props.user, buyer_vendor: false });
    }
    this.refreshDataSet("buyerSellers");
  };

  handleSectionSave = async (patch) => {
    this.setState(
      {
        ...patch,
        modified: true,
      },
      async () => {
        await this.handleBlur();
      }
    );
  };

  handleSectionWarning = (message) => {
    this.setState({
      errorMessage: message,
      showAlert: true,
    });
  };

  render() {
    const sectionKey = this.state.sale_id || "new";
    const propertyState = this.state.propertySales.length > 0 ? this.state.propertySales[0].state : null;

    return (
      <div className="Sale">
        {this.state.isLoading && (
          <div className="outer-div">
            <div className="sweet-loading inner-div">
              <PacmanLoader
                cssOverride={{
                  display: "block",
                  margin: "0 auto",
                }}
                size={20}
                color={"#e03c31"}
                loading={this.state.isLoading}
              />
            </div>
          </div>
        )}
        {this.state.showOwnerSearchDialog && <OwnerSearchModal isAuthenticated={this.props.isAuthenticated} user={this.props.user} userPermissions={this.props.userPermissions} toggleOwnerSearchDialog={this.toggleOwnerSearchDialog} show={this.state.showOwnerSearchDialog} saleid={this.state.sale_id} properties={this.state.propertySales} controlType="table1" buyerSellers={this.state.buyerSellers} updateTableState={this.updateTableState} saveRecord={this.saveRecord} deleteRecord={this.deleteRecord} refreshDataSet={this.refreshDataSet} />}

        {this.state.sale && this.props.isAuthenticated && !this.state.isLoading && (
          <div className="SaleForm">
            <Form>
              <Row>
                <Col lg={3}></Col>
                <Col>
                  <Nav className="justify-content-center ">
                    {this.state.previousId !== null && this.state.idList.length > 0 && (
                      <Nav.Item>
                        <LinkContainer to={`/sales/${this.state.previousId}`} state={{ data: this.state.idList, propertyidlist: this.state.propertyidlist }}>
                            <Button type="button" size="sm" className="btn-teal">
                            Previous
                          </Button>
                        </LinkContainer>{" "}
                      </Nav.Item>
                    )}
                    {this.state.nextId !== null && this.state.idList.length > 0 && (
                      <Nav.Item>
                        <LinkContainer to={`/sales/${this.state.nextId}`} state={{ data: this.state.idList, propertyidlist: this.state.propertyidlist }}>
                            <Button type="button" size="sm" className="btn-teal">
                            Next
                          </Button>
                        </LinkContainer>{" "}
                      </Nav.Item>
                    )}
                    {this.state.currentIdIndex !== null && this.state.idList.length > 0 && (
                      <Form.Group as={Row} controlId="currentIdIndex">
                        <Col className="zeroPadRight">
                          <Form.Control onChange={this.handleCurrentIdIndexChange} value={this.state.currentIdIndex + 1} as="input" type="text" min="0" className="pageCount" onBlur={this.handleGoToRecord} onKeyDown={this.handleEnterCurrentIdIndex} />
                        </Col>
                        <Col className="zeroPadLeft">
                          <h6>
                            <div className="topPad">of {this.state.idList.length} </div>
                          </h6>
                        </Col>
                      </Form.Group>
                    )}
                  </Nav>
                </Col>
                <Col>
                  <Nav className="justify-content-end ">
                    <Nav.Item>
                      <a target="_blank" href="/cityscopes">
                        <Button variant="primary" type="button" size="sm">
                          Add/Edit Cityscopes
                        </Button>{" "}
                      </a>
                    </Nav.Item>

                    {/* <Nav.Item>

                            {this.state.propertySales.length>0 && <LinkContainer to={`/properties/${this.state.propertySales[0].property_key}`} >
                                <Button type="button" variant="primary" size="sm">Back to Property {this.state.propertySales[0].property_key}</Button></LinkContainer>}
                                {" "}
                                </Nav.Item> */}
                    <Nav.Item>
                      <Button type="button" variant="primary" size="sm" onClick={this.handleBuildSalesText}>
                        Build Sales Text
                      </Button>{" "}
                      <Form.Check checked={this.state.textDates} onChange={this.handleCheckBoxChange} label="Dates as Text" type="checkbox" name="textDates" size="sm" onBlur={this.handleBlur} />
                    </Nav.Item>
                    <Nav.Item>
                      <Button type="button" variant="danger" onClick={this.handleDelete} size="sm">
                        Delete
                      </Button>
                    </Nav.Item>
                  </Nav>
                </Col>
              </Row>
              <Row id="detail">
                <Col>
                  <Modal
                    show={this.state.showAlert}
                    onHide={(e) => {
                      this.setState({ showAlert: !this.state.showAlert });
                    }}
                    centered
                  >
                    <Modal.Header closeButton>
                      {" "}
                      <Modal.Title>Uh Oh!</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      {" "}
                      <Alert variant="danger">{this.state.errorMessage}</Alert>{" "}
                    </Modal.Body>
                  </Modal>
                  <Tabs defaultActiveKey={0} id="tabset">
                    <Tab eventKey={0} title="Sale Detail">
                      <Card id="saledetails">
                        <Card.Body>
                          <Row>
                            <Col sm={12} md={6} lg={3}>
                              <div className="mb-3">
                                <SaleCoreFields
                                  key={`core-${sectionKey}-${this.state.classification_code || "none"}`}
                                  saleId={this.state.sale_id}
                                  initialValues={this.state}
                                  appendixOptions={this.state.appendixOptions}
                                  classificationOptions={this.state.classificationOptions}
                                  onSave={this.handleSectionSave}
                                />
                              </div>
                              <div className="mb-3">
                              <DuplicateCheckCard
                                key={`dup-${sectionKey}`}
                                checked={this.state.checked_duplicate}
                                onSave={this.handleSectionSave}
                              />
                              </div>
                            </Col>

                            <Col sm={12} md={6} lg={3}>
                              <div className="mb-3">
                                <SaleFlagsPanel
                                  key={`flags-${sectionKey}`}
                                  values={this.state}
                                  partInterestOverride={this.state.part_interest}
                                  onSave={this.handleSectionSave}
                                />
                              </div>

                              <AgentSelector
                                key={`agents-${sectionKey}`}
                                entityIdAgent={this.state.entity_id_agent}
                                agent={this.state.agent}
                                agentName={this.state.agent_name}
                                entityIdCoAgent={this.state.entity_id_co_agent}
                                coAgent={this.state.co_agent}
                                coAgentName={this.state.co_agent_name}
                                propertyState={propertyState}
                                saleId={this.state.sale_id}
                                onSave={this.handleSectionSave}
                                onWarning={this.handleSectionWarning}
                              />
                            </Col>
                            <Col sm={12} md={6} lg={6}>
                              <SaleRelationsPanel
                                propertySaleFilter={this.state.propertySaleFilter}
                                isAuthenticated={this.props.isAuthenticated}
                                user={this.props.user}
                                propertySales={this.state.propertySales}
                                updateTableState={this.updateTableState}
                                saveRecord={this.saveRecord}
                                validateRelatedRecord={this.validateRelatedRecord}
                                deleteRecord={this.deleteRecord}
                                removeHold={this.removeHold}
                                saleId={this.state.sale_id}
                                areaSum={this.state.areaSum}
                                getProperties={this.getProperties}
                                propertyidlist={this.state.propertyidlist || []}
                                userPermissions={this.props.userPermissions}
                                onAddOwnerAsBuyerSeller={this.addOwnerAsBuyerSeller}
                                onRemoveVendorAsOwner={this.removeVendorAsOwner}
                                onToggleOwnerSearchDialog={this.toggleOwnerSearchDialog}
                                buyerSellers={this.state.buyerSellers}
                                refreshDataSet={this.refreshDataSet}
                                buyerSellerOptions={this.state.buyerSellerOptions}
                              />
                            </Col>
                          </Row>
                        </Card.Body>
                      </Card>
                    </Tab>
                    <Tab eventKey={4} title="Record History">
                      <RecordHistoryTab
                        createdDate={this.state.created_date}
                        createdBy={this.state.created_by}
                        lastEditedDate={this.state.last_edited_date}
                        lastEditedBy={this.state.last_edited_by}
                      />
                    </Tab>
                  </Tabs>
                </Col>
              </Row>
            </Form>
          </div>
        )}
      </div>
    );
  }
}

function SaleDetailWithRouter(props) {
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const history = {
    push: (to, state) => {
      if (typeof to === "string") {
        navigate(to, state ? { state } : undefined);
        return;
      }

      if (to && typeof to === "object") {
        const pathname = to.pathname || "";
        const nextState = to.state !== undefined ? to.state : state;
        navigate(pathname, nextState ? { state: nextState } : undefined);
      }
    },
    replace: (to, state) => navigate(to, { replace: true, ...(state ? { state } : {}) }),
  };

  const match = { params };

  return <SaleDetail {...props} match={match} location={location} history={history} />;
}

export default SaleDetailWithRouter;
